import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { adminGuard, userGuard, candidateGuard } from './login/auth.guard';
import { CandidateLoginComponent } from './login/candidate-login/candidate-login.component';
import { CandidateRegisterComponent } from './login/candidate-register/candidate-register.component';
import { VerifyEmailComponent } from './login/verify-email/verify-email.component';
import { ClaimApplicationsComponent } from './login/claim-applications/claim-applications.component';
import { UserComponent } from './applicant/applicant-quiz/user/user.component';
import { LoginComponent } from './login/login/login.component';
import { PasswordChangeComponent } from './login/password-change/password-change.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { TermsAndConditionsPageComponent } from './applicant/applicant-quiz/terms-and-conditions-page/terms-and-conditions-page.component';
import { PolicyPrivacyPageComponent } from './applicant/applicant-quiz/policy-privacy-page/policy-privacy-page.component';
import { CampaignLandingPageComponent } from './applicant/applicant-quiz/campaign-landing-page/campaign-landing-page.component';
import { PublicComponent } from './public/public.component';
import { HomePageComponent } from './public/home-page/home-page.component';
import { ContactUsPageComponent } from './public/contact-us-page/contact-us-page.component';
import { ThankYouForContactPageComponent } from './public/contact-us-page/thank-you-for-contact-page/thank-you-for-contact-page.component';
import { AboutUsPageComponent } from './public/about-us-page/about-us-page.component';
import { PrivacyPolicyPageComponent } from './public/privacy-policy-page/privacy-policy-page.component';
import {
  ThankYouPageComponent
} from "./applicant/applicant-quiz/thank-you-page/thank-you-page.component";
import { CvUploadComponent } from './cv-upload/cv-upload.component';
import { MagicLoginComponent } from './cv-upload/magic-login.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: 'home',
        component: HomePageComponent,
      },
      {
        path: 'about-us',
        component: AboutUsPageComponent,
      },
      {
        path: 'contact-us',
        component: ContactUsPageComponent,
      },
      {
        path: 'thank-you-for-contact-us',
        component: ThankYouForContactPageComponent,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyPageComponent,
      },
    ],
  },
  { path: 'signin', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'password-change', component: PasswordChangeComponent },
  { path: 'candidate-login', component: CandidateLoginComponent },
  { path: 'candidate-register', component: CandidateRegisterComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'claim-applications', component: ClaimApplicationsComponent },
  {
    canActivate: [candidateGuard],
    loadChildren: () =>
      import('./candidate/candidate.module').then(m => m.CandidateModule),
    path: 'candidate',
  },
  {
    canActivate: [adminGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    path: 'admin',
  },
  {
    canActivate: [userGuard],
    loadChildren: () =>
      import('./client/client.module').then(m => m.ClientModule),
    path: 'dashboard',
  },
  // {
  //   path: 'public',
  //   component: PublicComponent,
  // },
  {
    path: 'lp/:urlId',
    redirectTo: 'clp/:urlId',
  },
  {
    path: 'clp/:urlId',
    component: CampaignLandingPageComponent,
  },
  { path: 'q/:urlId', component: UserComponent },
  { path: 'thank-you/:urlId', component: ThankYouPageComponent },
  { path: 'privacy-policy/:urlId', component: PolicyPrivacyPageComponent },
  {
    path: 'terms-and-conditions/:urlId',
    component: TermsAndConditionsPageComponent,
  },
  { path: 'upload-cv', component: CvUploadComponent },
  { path: 'magic-login', component: MagicLoginComponent },
  // TODO page-not-found handling
  // { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'signin' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
